class Snippet {
  constructor({ id, isAuth, prehead = null, head = null, body = null }) {
    this.id = id
    this.isAuth = isAuth
    this.prehead = prehead ?? null
    this.head = head ?? null
    this.body = body ?? null
  }

  removeSnippet() {
    if (this.prehead) document.head.removeChild(this.prehead)
    if (this.head) document.head.removeChild(this.head)
    if (this.body) document.body.removeChild(this.body)
  }
}

export default {
  data() {
    return {
      // Array<Snippet>
      gtmSnippets: [],
    }
  },
  computed: {
    loginStatus() {
      return this.$store.state.common.loginStatus
    },
    userEmail() {
      return this.$store.state.common.email
    },
  },
  watch: {
    loginStatus(loginStatus) {
      if (!loginStatus) {
        this.removeAuthSnippets()
      }
    },
    userEmail(userEmail) {
      if (userEmail) {
        this.addUserEmailGtmSnippet(userEmail)
      }
    },
  },
  mounted() {
    if (/\.(net)\/?$/.test(window.location.host)) {
      // '.net'
      // this.addGtagSnippet('TWZJV6JNK8')
      this.addGtmSnippet('MN33RZF7')
    } else {
      // '.com'
      this.addGtagSnippet('P7MKL5036N')
      this.addGtmSnippet('MZ3D6H8V')
    }

    if (this.userEmail) {
      this.addUserEmailGtmSnippet(this.userEmail)
    }
  },
  beforeDestroy() {
    this.removeAllSnippets()
  },
  methods: {
    addGtagSnippet(gtagId, isAuth = false) {
      this.removeSnippet(gtagId)

      const gtmPreheadSnippet = document.createElement('script')
      gtmPreheadSnippet.setAttribute('async', true)
      gtmPreheadSnippet.src = `https://www.googletagmanager.com/gtag/js?id=G-${gtagId}`
      document.head.appendChild(gtmPreheadSnippet)

      const gtmHeadSnippet = document.createElement('script')
      gtmHeadSnippet.setAttribute('type', 'text/javascript')
      gtmHeadSnippet.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', 'G-${gtagId}');
        `
      document.head.appendChild(gtmHeadSnippet)

      const gtmSnippet = new Snippet({ id: gtagId, isAuth: isAuth, prehead: gtmPreheadSnippet, head: gtmHeadSnippet })
      this.gtmSnippets.push(gtmSnippet)
    },
    addGtmSnippet(gtmId, isAuth = false) {
      this.removeSnippet(gtmId)

      const gtmHeadSnippet = document.createElement('script')
      gtmHeadSnippet.innerHTML = `
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', 'GTM-${gtmId}');
        `
      document.head.appendChild(gtmHeadSnippet)

      const gtmBodySnippet = document.createElement('noscript')
      const iframe = document.createElement('iframe')
      iframe.width = 0
      iframe.height = 0
      iframe.style = 'display: none; visibility: hidden'
      iframe.src = `https://www.googletagmanager.com/ns.html?id=GTM-${gtmId}`
      gtmBodySnippet.appendChild(iframe)
      document.body.appendChild(gtmBodySnippet)

      const gtmSnippet = new Snippet({ id: gtmId, isAuth: isAuth, head: gtmHeadSnippet, body: gtmBodySnippet })
      this.gtmSnippets.push(gtmSnippet)
    },
    addUserEmailGtmSnippet(userEmail, isAuth = true) {
      this.removeSnippet(userEmail)

      const gtmHeadSnippet = document.createElement('script')
      gtmHeadSnippet.setAttribute('type', 'text/javascript')
      gtmHeadSnippet.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'userEmail': '${userEmail}' });
      `
      document.head.appendChild(gtmHeadSnippet)

      const gtmSnippet = new Snippet({ id: userEmail, isAuth: isAuth, head: gtmHeadSnippet })
      this.gtmSnippets.push(gtmSnippet)
    },
    removeSnippet(id) {
      const snippet = this.gtmSnippets.find(snippet => snippet.id === id)
      if (snippet) {
        snippet.removeSnippet()
        this.gtmSnippets = this.gtmSnippets.filter(snippet => snippet.id !== id)
      }
    },
    removeAuthSnippets() {
      this.gtmSnippets.forEach(snippet => {
        if (snippet.isAuth) {
          snippet.removeSnippet()
        }
      })
      this.gtmSnippets = this.gtmSnippets.filter(snippet => !snippet.isAuth)
    },
    removeAllSnippets() {
      this.gtmSnippets.forEach(snippet => {
        snippet.removeSnippet()
      })
      this.gtmSnippets = []
    },
  },
}
